export const REPORT_TEMPLATE_STORAGE_KEY = 'report_pdf_template_default';
export const LETTER_HEADER_STORAGE_KEY = 'letter_header_template_default';

export const REPORT_TEMPLATE_OPTIONS = [
  {
    value: 'scholar_modern',
    label: 'Scholar Modern',
    headline: 'Bold academic hierarchy',
    description: 'Best for result sheets, rankings, and polished academic reports.',
    pdfVariant: 'MODERN',
  },
  {
    value: 'campus_classic',
    label: 'Campus Classic',
    headline: 'Formal administrative style',
    description: 'Works well for receipts, official reports, and traditional school communication.',
    pdfVariant: 'CLASSIC',
  },
  {
    value: 'minimal_grid',
    label: 'Minimal Grid',
    headline: 'Clean compact layout',
    description: 'Great for dense result tables and simple document exports.',
    pdfVariant: 'MINIMAL',
  },
  {
    value: 'merit_redline',
    label: 'Merit Redline',
    headline: 'Strong red-accent sheets',
    description: 'Gives report cards a sharper branded look while keeping familiar structure.',
    pdfVariant: 'MODERN',
  },
  {
    value: 'principal_bluebook',
    label: 'Principal Bluebook',
    headline: 'Ledger-inspired reports',
    description: 'Good for finance reports, summary documents, and management packs.',
    pdfVariant: 'CLASSIC',
  },
  {
    value: 'simple_white',
    label: 'Simple White',
    headline: 'Quiet minimal export',
    description: 'Useful when you want data-first PDFs with very little decoration.',
    pdfVariant: 'MINIMAL',
  },
  {
    value: 'honours_panel',
    label: 'Honours Panel',
    headline: 'Premium report-card styling',
    description: 'Designed for result cards and top-performer style summaries.',
    pdfVariant: 'MODERN',
  },
  {
    value: 'record_register',
    label: 'Record Register',
    headline: 'Traditional school-office feel',
    description: 'Fits notices, event records, and year-end printed registers.',
    pdfVariant: 'CLASSIC',
  },
  {
    value: 'exam_compact',
    label: 'Exam Compact',
    headline: 'Row-heavy mark sheets',
    description: 'Optimized for class result PDFs and tightly packed mark tables.',
    pdfVariant: 'MINIMAL',
  },
  {
    value: 'trust_board',
    label: 'Trust Board',
    headline: 'Executive summary format',
    description: 'Balanced layout for leadership review packets and school-wide summaries.',
    pdfVariant: 'MODERN',
  },
];

export const LETTER_HEADER_OPTIONS = [
  { value: 'classic_center', label: 'Classic Center', description: 'Centered school name with strong divider.' },
  { value: 'stacked_left', label: 'Left Stacked', description: 'Traditional left-aligned school identity block.' },
  { value: 'compact_line', label: 'Compact Line', description: 'Single-line compact header for tight documents.' },
  { value: 'two_line', label: 'Two Line Center', description: 'Balanced centered header with two-line identity.' },
  { value: 'name_only', label: 'School Name Only', description: 'Minimal header showing just the school name.' },
  { value: 'name_address_only', label: 'Name + Address', description: 'Simple formal header without extra decoration.' },
  { value: 'brand_bar', label: 'Color Bar Header', description: 'Branded line header with stronger color accent.' },
  { value: 'accent_left', label: 'Accent Left', description: 'Modern left accent strip for official letters.' },
  { value: 'circular_seal', label: 'Circular Seal', description: 'Seal-style official header for formal certificates.' },
  { value: 'letterhead_line', label: 'Letterhead Line', description: 'A clean institutional letterhead with colored rule.' },
  { value: 'circular_double', label: 'Circular Double', description: 'Double-ring official mark with formal identity block.' },
  { value: 'letterhead_center_bar', label: 'Letterhead Center Bar', description: 'Centered institutional letterhead with solid band.' },
  { value: 'logo_left', label: 'Logo Left', description: 'Logo-first left-aligned identity strip.' },
  { value: 'logo_center', label: 'Logo Center', description: 'Centered crest style for formal letters and certificates.' },
  { value: 'split_band', label: 'Split Band', description: 'Split left-right header for documents needing clean structure.' },
];

export const resolveReportTemplate = (rawValue) =>
  REPORT_TEMPLATE_OPTIONS.find((option) => option.value === rawValue) || REPORT_TEMPLATE_OPTIONS[0];

export const resolveLetterHeader = (rawValue) =>
  LETTER_HEADER_OPTIONS.find((option) => option.value === rawValue) || LETTER_HEADER_OPTIONS[0];
